import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type NzFeesDealerMarketDataFragment = (
  { __typename: 'NzFeesDealershipMarket' }
  & Pick<SchemaTypes.NzFeesDealershipMarket, 'viewable'>
  & { overrides: Array<(
    { __typename: 'NzFeesDealershipMarketOverrides' }
    & Pick<SchemaTypes.NzFeesDealershipMarketOverrides, 'dealerId' | 'viewable'>
  )> }
);

export const NzFeesDealerMarketDataFragmentDoc = /*#__PURE__*/ gql`
    fragment NzFeesDealerMarketData on NzFeesDealershipMarket {
  viewable
  overrides {
    dealerId
    viewable
  }
}
    `;